/*____________ Config ____________*/
export let tour = {
    title: 'Chipinaw',
    map: false,
    infoSidebar: false,
    watermark: true,
    websiteUrl: 'https://www.chipinaw.com/',
    requestInfoUrl: null,

  
    colors: {
        themeColor: 0x6d0f13,
        // loaderColor: <value>,
        // hamburgerMenuBgColor: <value>,
        // nextSceneBgColor: <value>,
        // prevSceneBgColor: <value>,
        // thumbsGridTextColor: <value>,
        // thumbsGridTextBgColor: <value>,
        // thumbsGridContainerBgColor: <value>,
        // thumbsGridBottomMenuBgColor: <value>,
        // sceneButtonBgColor: <value>,
    },
    
    loadingLogo: {
        src: './images/logo.png',
        width: 500,
    },

    logo: {
        src: './images/logo.png',
        width: 250,
        height: 135,

        mobile: { 
            src: './images/logo.png',
            width: 140,
        }
    },

    sceneLogos: false,
    mapLogo: false,
    audio: { loop: true, resumable: true },
}

tour.logo.mobile.height = tour.logo.mobile.width * tour.logo.height / tour.logo.width

/*____________ Stores ____________*/

/**
 * https://svelte.dev/docs#run-time-svelte-store-writable
 * 
 * store = writable(value?: any, start?: (set: (value: any) => void) => () => void)
 * 
 * Function that creates a store which has values that can be set from 'outside' components. 
 * It gets created as an object with additional set and update methods.
 * 
 * store = readable(value?: any, start?: (set: (value: any) => void) => () => void)
 * 
 * Creates a store whose value cannot be set from 'outside', 
 * the first argument is the store's initial value, 
 * and the second argument to readable is the same as the second argument to writable.
 */ 

import { writable } from 'svelte/store';

tour.scenes = writable([]);

if(typeof tour.map === 'object'){
    tour.mapZoom = writable();
}

/*____________ Tour Functions ____________*/

tour.switchView = () => {
    expandedTour = !expandedTour
    expandedMap = !expandedMap
    expandedTour ? showHotspots() : hideHotspots();
    setMapZoom();
}

tour.setMapZoom = () => {
    let zoomExpandedMap = 16.75
    let zoomMiniMap = 15
    let zoomLevel = expandedMap ? zoomExpandedMap : zoomMiniMap
    tour.mapZoom.set(zoomLevel);
    return zoomLevel;
}

tour.showHotspots = () => {
    console.log('show_hotspots')
    window.CC.krpano.call('show_hotspots');
}

tour.hideHotspots = () => {
    console.log('hide_hotspots')
    window.CC.krpano.call('hide_hotspots');
}

tour.nextScene = () => {
    window.CC.krpano.call('nextscene_loop(+1)')
}

tour.prevScene = () => {
    window.CC.krpano.call('nextscene_loop(-1)')
}

tour.loadScene = (scene) => {
    let sceneName = typeof scene === 'string' ? scene : scene.name;
    window.CC.krpano.call(`loadscene(${sceneName}, NULL, MERGE, SLIDEBLEND(0.5, 90, 0.2, linear) )`)
}

tour.parseContent = (content) => {
    return content
        .replaceAll('[', '<')
        .replaceAll(']', '>')
}

tour.getFirstScene = () => {
    return window.CC.krpano.get('scene[0]');
}

tour.getFirstSceneName = () => {
    return window.CC.krpano.get('scene[0].name');
}

tour.title = tour.parseContent(tour.title);

tour.currentScene = {
    getScene: () => {
        return window.CC.krpano.get('scene[get(xml.scene)]')
    },

    getName: () => {
        return window.CC.krpano.get('xml.scene')
    },

    getIndex: () => {
        return window.CC.krpano.get('scene[get(xml.scene)].index')
    },

    getHotspots: () => {
        let validStyles = [
            'skin_hotspotstyle', 
            'skin_hotspotstyle_balloon',
        ]

        let hotspots = 
            window.CC.krpano.get('hotspot').getArray()
            .filter((hs)=>{
                return validStyles.includes(hs.style)
            })
        
        return hotspots;
    },

    getHotspot: (name) => {
        return window.CC.krpano.get(`hotspot[${name}]`)
    },

    getGallery: (name) => {
        let galleryObj = window.CC.krpano.get(`gallery[${name}]`)
        let gallery = galleryObj.img.getArray().map((galleryImg)=>{
            return galleryImg.url.replace('%SWFPATH%', '.');
        })
        return gallery;
    },


    removeHotspot: (hs) => {
        window.CC.krpano.call('removehotspot(' + hs.name + ')');
    },

    getContent: () => {
        return window.CC.krpano.get('xml').content
    },

    getLogo: () => {
        return window.CC.krpano.get('scene[get(xml.scene)].logo')
    },

    getView: () => {
        return window.CC.krpano.get('xml.view');
    },

    getCurrentView: () => {
        return window.CC.krpano.get('view')
    },

    getPosition: () => {
        let view = tour.currentScene.getCurrentView();
        let position = { ath: view.hlookat, atv: view.vlookat }
        return position;
    },
}

tour.editor = {
    getContent: () => {
        return window.CC.krpano.get('xml').content
    },

    moveHotspot: (hs, x, y) =>{
        let pos = window.CC.krpano.screentosphere(x, y);
        hs.ath = pos.x
        hs.atv = pos.y
    },

    startMoveMode: () => {
        // sync mouse with current mouse position
        window.addEventListener('mousemove', (e)=>{
            let mouse = { x: e.clientX, y: e.clientY }
            let hs = tour.currentScene.getHotspots()[2]
            tour.editor.moveHotspot(hs, mouse.x, mouse.y)
        })
    },

    updateHotspotClicks: () => {
        let hotspots = currentScene.getHotspots()
        hotspots.forEach((hs)=>{
            // set onclick to log the hotspot name
            hs.ondown = () => { console.log(hs.name)}
            // set child ondown if present
            if(hs._childs){
                hs._childs.forEach((child)=>{
                    child.ondown = () => { console.log(child.name)}
                })
            }
        })
    },
    
    setView: (view) => {
    },

    addHotspot: () => {
        let hotspot = {
            name: 'hotspot_' + Math.random(),
            style: 'skin_hotspotstyle',
            ath: 0,
            atv: 0,
            ondown: 'console.log(name)',
        }
        window.CC.krpano.call('addhotspot(' + JSON.stringify(hotspot) + ')');

    },

    removeHotspot: (hs) => {
        window.CC.krpano.call('removehotspot(' + hs.name + ')');
    },
}

tour.setupColors = () => {
    for(let key in tour.colors){
        let rgb = hexToRgbString(tour.colors[key])
        let hex = hexToString(tour.colors[key])

        setStyleVar(kebabCase(key)+'-rgb', rgb);
        setStyleVar(kebabCase(key), hex);
        
        tour.colors[key+'Rgb'] = rgb;
        tour.colors[key+'Hex'] = hex;
    }
}

// Private functions
function hexToRgb(hex) {
    let r = hex >> 16;
    let g = hex >> 8 & 0xFF;
    let b = hex & 0xFF;
    return [r,g,b];
}

function rgbToString(rgb){
    return +rgb[0]+','+rgb[1]+','+rgb[2];
}

function hexToRgbString(hex) {
    let rgb = hexToRgb(hex);
    return rgbToString(rgb);
}

function hexToString(hex) {
    // convert hex to string
    let str = hex.toString(16);
    // pad with leading zeros
    while (str.length < 6) { str = '0' + str; }
    // #rrggbb
    return '#' + str.toUpperCase();
}

function setStyleVar(name, value){
    if(!name.startsWith('--')){ name = '--' + name; }
    document.documentElement.style.setProperty(name, value);
}

function kebabCase(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
